import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { AES, enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import swal from "sweetalert";
import Select from "react-select";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Alert from "@mui/material/Alert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./OrderTracking.css";
import SalesOrderNew from "../SalesNew/SalesOrderNew";
import DeliveryNote from "../SalesNew/DeliveryNote";
import QuotationNew from "../SalesNew/QuotationNew";
import EnquiryDetails from "../Enquiry/EnquiryDetails";
import QuotesDetails from "../SalesNew/QuotesDetails";
import FollowupInvoice from "../SalesNew/FollowupInvoice";
import ProcurementTracking from "./ProcurementTracking";
const OrderTracking = ({
  customerName,
  customerId,
  batchNo,
  quoteNumber,
  handleCancle,
  navigation,
}) => {
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const jwtToken = localStorage.getItem("jwtToken");
  const [activePopup, setActivePopup] = useState(null);
  const [showTrackOrder, setShowTrackOrder] = useState(true);
  const [showSalesOrder, setShowSalesOrder] = useState(false);
  const [showDeliveryNote, setShowDelibveryNote] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showEnquiryDeatils, setShowEnquiryDetails] = useState(false);
  const [showQuotation, setShowQuotation] = useState(false);
  const [showQuotationDetails, setShowQuotationDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [custName, setCustName] = useState("");
  const [custId, setCustId] = useState("");
  const [enqId, setEnqId] = useState("");
  const [quoteId, setQuoteId] = useState("");
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [showMessagesModal, setShowMessagesModal] = useState(false);
  const [showProcurementProcess, setShowProcurementProcess] = useState(false);
  const [isMessageSubmitted, setIsMessageSubmitted] = useState(false);
  const [stepStatuses, setStepStatuses] = useState([]);

  const [selectedDate, setSelectedDate] = useState(null); // Add state for DatePicker
  const [purchaseOrderFiles, setPurchaseOrderFiles] = useState([]);
  const [quotationFiles, setQuotationFiles] = useState([]);
  const [salesOrderFiles, setSalesOrderFiles] = useState([]);
  const [deliveryNoteFiles, setDeliveryNoteFiles] = useState([]);
  const [invoiceFiles, setInvoiceFiles] = useState([]);
  const [followUpFiles, setFollowUpFiles] = useState([]);
  const [damageFiles, setDamageFiles] = useState([]);
  const [enquiryFiles, setEnquiryFiles] = useState([]);
  const [dispatchFiles, setDispatchFiles] = useState([]);

  const [completedSteps, setCompletedSteps] = useState([]);
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [followUpMessages, setFollowUpMessages] = useState([]);

  const [showBreakageModal, setShowBreakageModal] = useState(false);
  const [breakageDescription, setBreakageDescription] = useState("");
  const [breakageStatus, setBreakageStatus] = useState("");

  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState("");
  const [damageDetails, setDamageDetails] = useState(null);
  const [showDamageDetailsModal, setShowDamageDetailsModal] = useState(false);

  const paymentOptions = [
    { value: "paid", label: "Paid" },
    { value: "not_paid", label: "Not Paid" },
    { value: "partially_paid", label: "Partially Paid" },
  ];

  const getDamageById = (id) => {
    setLoading(true);
    fetch(BASE_URL + `/getDamageById`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        id: id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200" || data.status === "success") {
          setDamageDetails(data.data);
          setShowDamageDetailsModal(true);
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch damage details:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching damage details:", error);
        setLoading(false);
      });
  };

  const handlePaymentStatusChange = (selectedOption) => {
    setSelectedPaymentStatus(selectedOption);
  };

  const handleBreakageSubmit = () => {
    console.log("breakage submitted");
    const damageData = {
      uniqueId: decryptedUniqueId,
      inquiryId: batchNo,
      description: breakageDescription,
      status: breakageStatus,
    };
    setLoading(true);
    fetch(BASE_URL + `/insertDamage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(damageData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "Breakage Submitted Successfully",
          });
          fetchFollwupDetails();
          setLoading(false);
          setBreakageDescription(""); // Clear message title
          setBreakageStatus(""); // Clear message content
        } else {
          console.error("Failed to insert Breakage", data.responseMessage);
          setLoading(false);
          swal({
            icon: "error",
            title: "Breakage Failed To Submit",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching insert Breakage:", error);
        setLoading(false);
      });
  };

  const handleStepCompletion = (currentStepIndex) => {
    // Always progress to the next step, but only if not already at the last step
    if (currentStepIndex < steps.length - 1) {
      setActiveStepIndex(currentStepIndex + 1);
    }

    // Mark the step as completed
    if (!completedSteps.includes(currentStepIndex)) {
      setCompletedSteps((prev) => [...prev, currentStepIndex]);
    }

    if (currentStepIndex === 2) {
      setLoading(true);
      fetch(BASE_URL + `/sceduleFollowUp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({
          uniqueId: decryptedUniqueId,
          inquiryId: batchNo,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.responseCode === "200") {
            setIsMessageSubmitted(false);
            setShowFollowUpModal(false);
            fetchFollwupDetails();
            setLoading(false);
          } else {
            console.error(
              "Failed to schedule follow-up:",
              data.responseMessage
            );
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error scheduling follow-up:", error);
          setLoading(false);
        });
    }
  };

  const [messageTitle, setMessageTitle] = useState("");
  const [messageContent, setMessageContent] = useState("");
  const [newValidationMessage, setValidationMessage] = useState("");

  const validateForm = () => {
    let newValidationMessage = "";

    if (!messageTitle.trim()) {
      newValidationMessage += "Title is required";
    } else if (!messageContent.trim()) {
      newValidationMessage += "Message content is required";
    } else if (!selectedDate) {
      newValidationMessage += "Please select a follow-up date";
    }

    setValidationMessage(newValidationMessage);
    return newValidationMessage === "";
  };

  const insertFollowupMessage = () => {
    console.log("Props check:", { customerId, batchNo });

    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    const followupData = {
      uniqueId: decryptedUniqueId,
      inquiryId: batchNo,
      title: messageTitle,
      description: messageContent,
      date: selectedDate.toISOString(),
    };
    setLoading(true);
    fetch(BASE_URL + `/insertFollowup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(followupData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          fetchFollwupDetails();
          setIsMessageSubmitted(true);
          setLoading(false);
          setMessageTitle(""); // Clear message title
          setMessageContent(""); // Clear message content
          setSelectedDate(null);
        } else {
          console.error("Failed to fetch Customer Name:", data.responseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
        setLoading(false);
      });
  };

  const insertPurchaseOrderFile = (file) => {
    const formData = new FormData();
    const purchaseOrderData = {
      uniqueId: decryptedUniqueId,
      inquiryId: batchNo,
    };
    formData.append("requestBody", JSON.stringify(purchaseOrderData));
    formData.append("files", file);
    setLoading(true);
    fetch(BASE_URL + `/insertPurchaseOrderFile`, {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setLoading(false);
          fetchFollwupDetails();
        } else {
          console.error("Failed to fetch Customer Name:", data.responseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
        setLoading(false);
      });
  };

  const insertFile = (file, stepType) => {
    const formData = new FormData();
    const fileData = {
      uniqueId: decryptedUniqueId,
      inquiryId: batchNo,
    };

    formData.append("requestBody", JSON.stringify(fileData));
    formData.append("files", file);

    let endpoint = "";

    // Determine the endpoint based on the step type
    switch (stepType) {
      case "Customer Purchase Order":
        endpoint = "/insertPurchaseOrderFile";
        break;
      case "Follow-Up":
        endpoint = "/insertFollowupFile";
        break;
      case "Sales Order":
        endpoint = "/insertSalesOrderFile";
        break;
      case "Delivery Note":
        endpoint = "/insertDelivaryChallanFile";
        break;
      case "Invoice":
        endpoint = "/insertInvoiceFile";
        break;
      case "Quotation":
        endpoint = "/insertQuoteFile";
        break;
      case "Breakage/Damage":
        endpoint = "/insertDamageFile";
        break;
      case "Dispatch":
        endpoint = "/insertDispatchFile";
        break;
      default:
        console.error("Unknown step type for file upload");
        return;
    }

    setLoading(true);
    fetch(BASE_URL + endpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setLoading(false);
          fetchFollwupDetails();
          // Update specific file state if needed
          getAllDocs();
        } else {
          console.error("Failed to upload file:", data.responseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setLoading(false);
      });
  };

  const getFollowup = () => {
    setLoading(true);
    fetch(BASE_URL + `/getFollowupByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setFollowUpMessages(data.data);
          setLoading(false);
        } else {
          console.error("Failed to fetch Followup:", data.responseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
        setLoading(false);
      });
  };

  const getPurchaseOrderFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getPurchaseOrderFileNameByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setPurchaseOrderFiles(data.fileNames);
          setLoading(false);
        } else {
          console.error("Failed to fetch Followup:", data.responseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
        setLoading(false);
      });
  };

  const getQuotationFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getQuoteFileNameByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setQuotationFiles(data.fileNames);
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch quotation files:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching quotation files:", error);
        setLoading(false);
      });
  };
  const getInvoiceFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getInvoiceFileNameByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setInvoiceFiles(data.fileNames);
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch quotation files:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching quotation files:", error);
        setLoading(false);
      });
  };
  const getDeliveryNoteFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getDeliveryFileNameByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setDeliveryNoteFiles(data.fileNames);
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch quotation files:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching quotation files:", error);
        setLoading(false);
      });
  };
  const getSalesOrderFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getSalesOrderFileNameByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setSalesOrderFiles(data.fileNames);
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch sales order files:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching sales order files:", error);
        setLoading(false);
      });
  };
  const getDamageFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getDamageFileNameByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setDamageFiles(data.fileNames);
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch sales order files:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching sales order files:", error);
        setLoading(false);
      });
  };
  const getFollowUpFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getFollowupFileNameByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setFollowUpFiles(data.fileNames);
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch sales order files:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching sales order files:", error);
        setLoading(false);
      });
  };

  const getDispatchFiles = () => {
    setLoading(true);
    fetch(BASE_URL + `/getDispatchFileNameByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        inquiryId: batchNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setDispatchFiles(data.fileNames);
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch sales order files:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching sales order files:", error);
        setLoading(false);
      });
  };

  const checkPreviousStepsCompleted = (currentStepIndex) => {
    // Check all previous steps (from 0 to currentStepIndex-1)
    for (let i = 0; i < currentStepIndex; i++) {
      if (stepStatuses[i] !== "Completed") {
        return false;
      }
    }
    return true;
  };

  const getAllDocs = () => {
    getPurchaseOrderFiles();
    getQuotationFiles();
    getInvoiceFiles();
    getDeliveryNoteFiles();
    getSalesOrderFiles();
    getDamageFiles();
    getFollowUpFiles();
    getDispatchFiles();
  };
  // Create similar functions for other file types...

  const [procurmentStatus, setProcurmentStates] = useState("");

  const fetchFollwupDetails = () => {
    setLoading(true);
    fetch(BASE_URL + `/fetchFollowUpDetailsByInquiryId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, inquiryId: batchNo }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          const statusData = data.data;
          const statuses = [
            statusData.inquiryStatus,
            statusData.quotationStatus,
            statusData.followupStatus,
            statusData.purchaseOrderStatus,
            statusData.salesOrderStatus,
            statusData.deliveryNoteCheckStatus,
            statusData.invoiceStatus,
            statusData.dispatchStatus,
            statusData.damageStatus,
            statusData.paymentStatus,
          ];

          setProcurmentStates(statusData.procurementProcess);

          // Set the step statuses
          setStepStatuses(statuses);

          // Calculate the active step (next one after the last "completed" step)
          const lastCompletedStepIndex = statuses.findIndex(
            (status) => status !== "Completed"
          );
          setActiveStepIndex(
            lastCompletedStepIndex === -1
              ? statuses.length - 1
              : lastCompletedStepIndex
          );
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch Follow-up details:",
            data.responseMessage
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchFollwupDetails();
    getDamageById(batchNo);
    getFollowup();
    getAllDocs();
  }, []);

  const handleNavigation = (key) => {
    if (navigation?.state?.routes[navigation.state.index].key !== key) {
      navigation.navigate(key);
    }
  };

  const handleCancleClick = () => {
    handleCancle();
  };

  const steps = [
    {
      title: "Enquiry",
      icon: "info-circle",
      tooltip: "Step to collect customer enquiry",
    },
    {
      title: "Quotation",
      icon: "file-alt",
      tooltip: "Provide a detailed quotation",
    },
    {
      title: "Follow-Up",
      icon: "phone",
      tooltip: "Reach out for confirmation or feedback",
    },
    {
      title: "Customer Purchase Order",
      icon: "shopping-cart",
      tooltip: "Confirm and place the purchase order",
    },
    {
      title: "Sales Order",
      icon: "file-invoice",
      tooltip: "Generate the sales order",
    },
    {
      title: "Delivery Note",
      icon: "warehouse",
      tooltip: "Record and track delivered goods accurately",
    },
    {
      title: "Invoice",
      icon: "file-invoice-dollar",
      tooltip: "Generate and send the invoice to the customer",
    },
    {
      title: "Dispatch",
      icon: "truck",
      tooltip: "Send out the order for delivery",
    },
    {
      title: "Breakage/Damage",
      icon: "exclamation-triangle",
      tooltip: "Handle any issues of breakage or damage",
    },
    {
      title: "Payment",
      icon: "money-check-alt",
      tooltip: "Receive the payment for the order",
    },
  ];

  const dispatchOptions = [
    { value: "dispatch", label: "Dispatch" },
    { value: "in_transport", label: "In Transport" },
    { value: "delivered", label: "Delivered" },
    { value: "not_delivered", label: "Not Delivered" },
  ];

  const customDispatchStyles = {
    control: (base) => ({
      ...base,
      minHeight: 35,
      minWidth: 200,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const handleCancleSalesOrder = () => {
    setShowTrackOrder(true);
    setShowSalesOrder(false);
    setShowDelibveryNote(false);
    setShowQuotation(false);
    setShowQuotationDetails(false);
    setShowEnquiryDetails(false);
    setShowInvoice(false);
    fetchFollwupDetails();
  };

  const handleCancleDeliveryNote = () => {
    setShowTrackOrder(true);
    setShowSalesOrder(false);
    setShowDelibveryNote(false);
    setShowQuotation(false);
    setShowQuotationDetails(false);
    setShowEnquiryDetails(false);
    setShowInvoice(false);
    fetchFollwupDetails();
  };

  const handleCancleInvoice = () => {
    setShowTrackOrder(true);
    setShowSalesOrder(false);
    setShowDelibveryNote(false);
    setShowQuotation(false);
    setShowQuotationDetails(false);
    setShowEnquiryDetails(false);
    setShowInvoice(false);
    fetchFollwupDetails();
  };

  const handleCancelQuotation = () => {
    setShowTrackOrder(true);
    setShowSalesOrder(false);
    setShowDelibveryNote(false);
    setShowQuotation(false);
    setShowQuotationDetails(false);
    setShowEnquiryDetails(false);
    setShowInvoice(false);
    fetchFollwupDetails();
  };

  const handleProcurementProcess = () => {
    setShowTrackOrder(false);
    setShowSalesOrder(false);
    setShowDelibveryNote(false);

    setShowQuotation(false);
    setShowQuotationDetails(false);
    setShowEnquiryDetails(false);
    setShowInvoice(false);

    setShowProcurementProcess(true);
    setShowMessagesModal(false);
    setShowBreakageModal(false);
    setShowDamageDetailsModal(false);
    setShowFollowUpModal(false);
  };

  const handleCancelProcurementProcess = () => {
    setShowTrackOrder(true);
    setShowSalesOrder(false);
    setShowDelibveryNote(false);
    setShowQuotation(false);
    setShowQuotationDetails(false);
    setShowEnquiryDetails(false);
    setShowInvoice(false);
    setShowProcurementProcess(false);
    fetchFollwupDetails();
  };

  const handleCancelQuotationDetails = () => {
    setShowTrackOrder(true);
    setShowSalesOrder(false);
    setShowDelibveryNote(false);
    setShowQuotation(false);
    setShowQuotationDetails(false);
    setShowInvoice(false);
    setShowEnquiryDetails(false);
  };

  const handleCancelEnquiryDetails = () => {
    setShowTrackOrder(true);
    setShowSalesOrder(false);
    setShowDelibveryNote(false);
    setShowQuotation(false);
    setShowQuotationDetails(false);
    setShowInvoice(false);
    setShowEnquiryDetails(false);
  };

  // Modify the FilePopup component:

  const FileUploadStep = ({
    step,
    index,
    activeStepIndex,
    onStepComplete,
    completedSteps,
  }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedDispatchStatus, setSelectedDispatchStatus] = useState("");
    const circleRef = React.useRef(null);

    const handleCircleClick = (index, stepTitle) => {
      const hasFiles =
        (stepTitle === "Customer Purchase Order" &&
          purchaseOrderFiles.length > 0) ||
        (stepTitle === "Quotation" && quotationFiles.length > 0) ||
        (stepTitle === "Sales Order" && salesOrderFiles.length > 0) ||
        (stepTitle === "Delivery Note" && deliveryNoteFiles.length > 0) ||
        (stepTitle === "Invoice" && invoiceFiles.length > 0) ||
        (stepTitle === "Follow-Up" && followUpFiles.length > 0) ||
        (stepTitle === "Breakage/Damage" && damageFiles.length > 0) ||
        (stepTitle === "Enquiry" && enquiryFiles.length > 0);

      if (hasFiles) {
        const circleElement = document.getElementById(`step-circle-${index}`);
        if (circleElement) {
          const rect = circleElement.getBoundingClientRect();
          setActivePopup({
            index,
            stepType: stepTitle,
            position: {
              top: rect.top + window.scrollY,
              left: rect.left + window.scrollX,
              width: rect.width,
              height: rect.height,
            },
          });
        }
      }

      if (stepTitle === "Sales Order") {
        if (stepStatuses[4] != "Completed") {
          if (customerId || customerName || batchNo) {
            setShowTrackOrder(false);
            setShowDelibveryNote(false);
            setShowEnquiryDetails(false);
            setShowSalesOrder(true);
            setCustId(customerId);
            setCustName(customerName);
            setEnqId(batchNo);
          }
        }
      }

      if (stepTitle === "Invoice") {
        if (stepStatuses[6] != "Completed") {
          if (customerId || customerName || batchNo) {
            setShowTrackOrder(false);
            setShowDelibveryNote(false);
            setShowEnquiryDetails(false);
            setShowSalesOrder(false);
            setShowInvoice(true);
            setCustId(customerId);
            setCustName(customerName);
            setEnqId(batchNo);
          }
        }
      }

      if (stepTitle === "Enquiry") {
        if (customerId || customerName || batchNo) {
          setShowTrackOrder(false);
          setShowDelibveryNote(false);
          setShowEnquiryDetails(true);
          setShowSalesOrder(false);
          setCustId(customerId);
          setCustName(customerName);
          setEnqId(batchNo);
        }
      }

      if (stepTitle === "Delivery Note") {
        if (stepStatuses[5] != "Completed") {
          if (customerId || customerName || batchNo) {
            setShowTrackOrder(false);
            setShowDelibveryNote(true);
            setShowQuotation(false);
            setShowEnquiryDetails(false);
            setShowSalesOrder(false);
            setCustId(customerId);
            setCustName(customerName);
            setEnqId(batchNo);
          }
        }
      }

      if (stepTitle === "Quotation") {
        if (stepStatuses[1] != "Completed") {
          if (customerId || customerName || batchNo) {
            setShowTrackOrder(false);
            setShowDelibveryNote(false);
            setShowEnquiryDetails(false);
            setShowQuotation(true);
            setShowSalesOrder(false);
            setCustId(customerId);
            setCustName(customerName);
            setEnqId(batchNo);
          }
        }
        if (stepStatuses[1] == "Completed") {
          if (customerId && customerName && batchNo && quoteNumber) {
            setShowTrackOrder(false);
            setShowDelibveryNote(false);
            setShowEnquiryDetails(false);
            setShowQuotation(false);
            setShowQuotationDetails(true);
            setShowSalesOrder(false);
            setCustId(customerId);
            setCustName(customerName);
            setEnqId(batchNo);
            setQuoteId(quoteNumber);
          }
        }
      }

      if (stepTitle === "Follow-Up") {
        setShowMessagesModal(true);
        getFollowup(); // Fetch follow-up messages when the modal is opened
      }

      if (stepTitle === "Breakage/Damage") {
        if (stepStatuses[7] != "Completed") {
          setShowBreakageModal(true);
        } else {
          setShowDamageDetailsModal(true);
        }
      }
    };

    const handleFileUpload = (e) => {
      if (!checkPreviousStepsCompleted(index)) {
        swal({
          title: "Previous Steps Not Completed",
          text: "Please complete all previous steps before uploading files for this step.",
          icon: "warning",
        });
        e.target.value = ""; // Clear the file input
        return;
      }

      const file = e.target.files[0];
      setSelectedFile(file);
    };

    // To this:
    const handleDispatchStatusChange = (selectedOption) => {
      setSelectedDispatchStatus(selectedOption);
    };
    const handleFileSubmit = () => {
      if (selectedFile) {
        // Call the generic file upload function with the current step title
        insertFile(selectedFile, step.title);

        // Complete the step if needed
        onStepComplete(index);

        // Clear the selected file after submission
        setSelectedFile(null);
      } else if (step.title === "Dispatch" && selectedDispatchStatus) {
        setLoading(true);
        fetch(BASE_URL + `/insertDispatchstatus`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            inquiryId: batchNo,
            uniqueId: decryptedUniqueId,
            message: selectedDispatchStatus.label,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.responseCode === "200") {
              setLoading(false);
              onStepComplete(index);
              setSelectedDispatchStatus("");
              fetchFollwupDetails();
            } else {
              setLoading(false);
              console.error(
                "Failed to update dispatch status:",
                data.responseMessage
              );
            }
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error updating dispatch status:", error);
          });
      } else if (step.title === "Payment" && selectedPaymentStatus) {
        // Handle payment status change
        setLoading(true);
        fetch(BASE_URL + `/insertFolloupPayment`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            uniqueId: decryptedUniqueId,
            inquiryId: batchNo,
            paymentStatus: selectedPaymentStatus.label,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.responseCode === "200") {
              setLoading(false);
              swal({
                icon: "success",
                title: "Payment status updated successfully",
              });
              fetchFollwupDetails();

              setSelectedPaymentStatus("");
            } else {
              console.error(
                "Failed to update payment status:",
                data.responseMessage
              );
              setLoading(false);
              swal({
                icon: "error",
                title: "Failed to update payment status",
              });
            }
          })
          .catch((error) => {
            console.error("Error updating payment status:", error);
            setLoading(false);
          });

        onStepComplete(index);
        setSelectedPaymentStatus("");
      }
    };

    const getCircleClassName = () => {
      const stepStatus = stepStatuses[index];
      if (stepStatus === "Completed") return "completed"; // Green
      if (index === activeStepIndex) return "active"; // Blue
      return "";
    };

    const renderStepContent = () => {
      // Handle Dispatch step
      if (step.title === "Dispatch") {
        return (
          <div className="d-flex flex-column align-items-center">
            {stepStatuses[7] === "Pending" && (
              <div>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                  style={{ display: "none" }}
                />
                <div className="d-flex mt-2">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </div>
            )}
            <Select
              className="mt-0"
              options={dispatchOptions}
              onChange={handleDispatchStatusChange}
              placeholder="Select Status"
              styles={customDispatchStyles}
              hideSelectedOptions
              isClearable
              value={selectedDispatchStatus}
            />

            {(selectedDispatchStatus || selectedFile) && (
              <button
                className="btn btn-xs active mx-2 mt-3"
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </div>
        );
      }

      if (step.title === "Follow-Up") {
        return (
          <div className="d-flex flex-column align-items-center">
            {stepStatuses[2] === "Pending" && (
              <>
                <div className="d-flex">
                  <button
                    className="file-upload-btn mt-2"
                    onClick={() => {
                      if (!checkPreviousStepsCompleted(index)) {
                        swal({
                          title: "Previous Steps Not Completed",
                          text: "Please complete all previous steps before uploading files for this step.",
                          icon: "warning",
                        });
                        return;
                      }
                      setShowFollowUpModal(true);
                    }}
                  >
                    <i className="fas fa-comments"></i>
                  </button>
                  <div className="" style={{ marginLeft: "5px" }}>
                    <input
                      type="file"
                      id={`file-step-${index}`}
                      className="file-upload"
                      onChange={handleFileUpload}
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor={`file-step-${index}`}
                      className="file-upload-btn mt-2"
                    >
                      <i className="fas fa-upload"></i>
                    </label>
                  </div>
                </div>
              </>
            )}
            {(isMessageSubmitted || selectedFile) && (
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={() => {
                  if (isMessageSubmitted) {
                    onStepComplete(index);
                  } else if (selectedFile) {
                    handleFileSubmit();
                  }
                }}
              >
                Submit
              </button>
            )}
          </div>
        );
      }

      if (step.title === "Enquiry") {
        return (
          <>
            {stepStatuses[0] === "Pending" && (
              <>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                />
                <div className="d-flex">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </>
            )}
            {selectedFile && (
              <button
                className={`btn mt-2 btn-xs ${selectedFile ? "active" : ""}`}
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </>
        );
      }

      if (step.title === "Quotation") {
        return (
          <>
            {stepStatuses[1] === "Pending" && (
              <>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                />
                <div className="d-flex">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </>
            )}

            {selectedFile && (
              <button
                className={`btn mt-2 btn-xs ${selectedFile ? "active" : ""}`}
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </>
        );
      }

      if (step.title === "Sales Order") {
        return (
          <>
            {stepStatuses[4] === "Pending" && (
              <>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                />
                <div className="d-flex">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </>
            )}
            {procurmentStatus === "YES" && (
              <>
                <button
                  className={`btn mt-2 btn-xs active`}
                  onClick={() => handleProcurementProcess()}
                >
                  Procurement Process
                </button>
              </>
            )}
            {selectedFile && (
              <button
                className={`btn mt-2 btn-xs ${selectedFile ? "active" : ""}`}
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </>
        );
      }

      // Handle Customer Purchase Order step
      if (step.title === "Customer Purchase Order") {
        return (
          <>
            {stepStatuses[3] === "Pending" && (
              <>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                />
                <div className="d-flex">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </>
            )}
            {selectedFile && (
              <button
                className={`btn mt-2 btn-xs ${selectedFile ? "active" : ""}`}
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </>
        );
      }

      if (step.title === "Delivery Note") {
        return (
          <>
            {stepStatuses[5] === "Pending" && (
              <>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                />
                <div className="d-flex">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </>
            )}
            {selectedFile && (
              <button
                className={`btn mt-2 btn-xs ${selectedFile ? "active" : ""}`}
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </>
        );
      }

      if (step.title === "Invoice") {
        return (
          <>
            {stepStatuses[6] === "Pending" && (
              <>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                />
                <div className="d-flex">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </>
            )}
            {selectedFile && (
              <button
                className={`btn mt-2 btn-xs ${selectedFile ? "active" : ""}`}
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </>
        );
      }

      if (step.title === "Breakage/Damage") {
        return (
          <>
            {stepStatuses[8] === "Pending" && (
              <>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                />
                <div className="d-flex">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </>
            )}
            {selectedFile && (
              <button
                className={`btn mt-2 btn-xs ${selectedFile ? "active" : ""}`}
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </>
        );
      }

      if (step.title === "Payment") {
        return (
          <div className="d-flex flex-column align-items-center">
            {stepStatuses[9] === "Pending" && (
              <div>
                <input
                  type="file"
                  id={`file-step-${index}`}
                  className="file-upload"
                  onChange={handleFileUpload}
                  style={{ display: "none" }}
                />
                <div className="d-flex mt-2">
                  <label
                    htmlFor={`file-step-${index}`}
                    className="file-upload-btn mx-2"
                  >
                    <i className="fas fa-upload"></i>
                  </label>
                </div>
              </div>
            )}
            <Select
              className="mt-0"
              options={paymentOptions}
              onChange={handlePaymentStatusChange}
              placeholder="Select Payment Status"
              styles={customDispatchStyles}
              hideSelectedOptions
              isClearable
              value={selectedPaymentStatus}
            />

            {(selectedPaymentStatus || selectedFile) && (
              <button
                className="btn btn-xs active mx-2 mt-3"
                onClick={handleFileSubmit}
              >
                Submit
              </button>
            )}
          </div>
        );
      }

      // For all other steps, return empty div to maintain spacing
      return <div className="file-upload-wrapper"></div>;
    };

    return (
      <div className="step-wrapper">
        <div className="step-content">
          <h6 className="step-title">{step.title}</h6>
          <div
            ref={circleRef}
            className={`step-circle ${getCircleClassName()}`}
            id={`step-circle-${index}`}
            onClick={() => handleCircleClick(index, step.title)}
          >
            <i className={`fas fa-${step.icon}`}></i>
            <div className="step-tooltip">{step.tooltip}</div>
          </div>

          {stepStatuses[index] === "Completed" && (
            <div className="completed-text">
              <h6 className="text-success">Completed</h6>
            </div>
          )}

          <div className="file-upload-wrapper">{renderStepContent()}</div>
        </div>
      </div>
    );
  };

  const FilePopup = ({ position, onClose, stepType }) => {
    let files = [];
    let filePath = "";

    switch (stepType) {
      case "Customer Purchase Order":
        files = purchaseOrderFiles;
        filePath = "purchaseOrderFiles";
        break;
      case "Quotation":
        files = quotationFiles;
        filePath = "quoteFiles";
        break;
      case "Sales Order":
        files = salesOrderFiles;
        filePath = "salesOrderFiles";
        break;
      case "Delivery Note":
        files = deliveryNoteFiles;
        filePath = "delivaryChallanFiles";
        break;
      case "Invoice":
        files = invoiceFiles;
        filePath = "invoiceFiles";
        break;
      case "Follow-Up":
        files = followUpFiles;
        filePath = "followupFiles";
        break;
      case "Breakage/Damage":
        files = damageFiles;
        filePath = "damageFiles";
        break;
      case "Enquiry":
        files = enquiryFiles;
        filePath = "enquiryFiles";
        break;
      default:
        files = [];
    }
    return (
      <div
        className="action-popup show"
        style={{
          position: "absolute",
          top: position ? `${position.top + position.height - 40}px` : "0",
          left: position
            ? `${position.left + position.width / 2 - 290}px`
            : "0",
        }}
      >
        <button
          className="close-popup-btn"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        <div className="fetched-files">
          {files.length === 0 ? ( // Check if there are no files
            <div className="text-center text-muted">
              <p>No files found.</p>
            </div>
          ) : (
            files.map((fileName, index) => (
              <div className="fetched-file" key={index}>
                <div className="file-info">
                  <div className="file-name">
                    <i className="fas fa-file"></i>
                    <span>{fileName}</span>
                  </div>
                </div>
                <div className="popup-actions">
                  <Button
                    variant="success"
                    className="mx-2"
                    onClick={() =>
                      window.open(
                        `https://trading.zarpsoftware.in/uploads/purchaseOrderFiles/${fileName}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="fas fa-eye"></i> Preview
                  </Button>
                  <Button
                    variant="primary"
                    className="mx-2"
                    onClick={() =>
                      window.open(
                        `https://trading.zarpsoftware.in/uploads/purchaseOrderFiles/${fileName}`,
                        "_blank"
                      )
                    }
                  >
                    <i className="fas fa-download"></i> Download
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="container-fluid ">
        <div className="page-content">
          <div className="center-div">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {showTrackOrder && (
        <Container fluid className="py-4">
          <Row className="justify-content-center">
            <Col lg={12} md={12}>
              <div className="my-3">
                <div className="px-2 d-flex align-items-center">
                  <div className="back-button" onClick={handleCancleClick}>
                    <ArrowBackIosIcon size={20} className="arrow-child" />
                  </div>
                  <h5
                    className="mt-1 mx-2 text-primary"
                    style={{ letterSpacing: "1px" }}
                  >
                    Track Order
                  </h5>
                </div>
              </div>

              <Card className="card-style">
                {newValidationMessage && (
                  <Alert severity="error" className="mt-0">
                    {newValidationMessage.split("\n").map((message, index) => (
                      <div key={index}>{message}</div>
                    ))}
                  </Alert>
                )}{" "}
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h6>
                        Tracking No :{" "}
                        <span className="mt-1 mx-2 text-primary font-20">
                          {batchNo}
                        </span>{" "}
                      </h6>

                      <h6>
                        Customer Name :{" "}
                        <span className="mt-1 mx-2 text-primary font-20">
                          {customerName}
                        </span>{" "}
                      </h6>
                    </div>
                    <div>
                      <Button
                        variant="primary"
                        className="mx-2"
                        onClick={() => handleProcurementProcess()}
                      >
                        Procurement Process
                      </Button>
                    </div>
                  </div>

                  <div className="text-center">
                    <div
                      className="main-content-label mb-4"
                      style={{ fontSize: "24px", fontWeight: "bold" }}
                    >
                      Add Enquiry Steps
                    </div>
                    <div className="progress-snake">
                      {steps.map((step, index) => (
                        <FileUploadStep
                          key={index}
                          step={step}
                          index={index}
                          activeStepIndex={activeStepIndex}
                          onStepComplete={handleStepCompletion}
                          completedSteps={completedSteps}
                        />
                      ))}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {activePopup !== null && (
            <FilePopup
              position={activePopup.position}
              onClose={() => setActivePopup(null)}
              stepType={activePopup.stepType}
            />
          )}

          <Modal
            show={showFollowUpModal}
            onHide={() => setShowFollowUpModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Follow-up Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Message Title</Form.Label>
                  <Form.Control
                    type="text"
                    className="message-title"
                    placeholder="Enter Message Title"
                    value={messageTitle}
                    onChange={(e) => setMessageTitle(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3 w-100">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    className="form-control message-box"
                    name="current_address"
                    required
                    value={messageContent}
                    onChange={(e) => setMessageContent(e.target.value)}
                    placeholder="Enter Your Message"
                  />
                </Form.Group>
                <Form.Group className="mb-3 next-followup-date">
                  <Form.Label>Next Follow-up Date</Form.Label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    required
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    minDate={new Date()}
                    placeholderText="Next Follow-Up Date"
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowFollowUpModal(false)}
              >
                Close
              </Button>
              <Button
                variant="primary"
                type="submit"
                onClick={() => {
                  insertFollowupMessage();
                  setShowFollowUpModal(false);
                }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showMessagesModal}
            onHide={() => setShowMessagesModal(false)}
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Follow-Up Messages</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {followUpMessages.length === 0 ? ( // Check if there are no messages
                <div className="text-center text-muted">
                  <p>No follow-up messages.</p>
                </div>
              ) : (
                <ul className="list-unstyled">
                  {followUpMessages.map((msg) => (
                    <li key={msg.id} className="mb-3 pb-3 border-bottom">
                      <h6>&bull;&nbsp;{msg.title}</h6>
                      <p>{msg.description}</p>
                      <small className="text-muted">
                        {new Date(msg.date).toLocaleString()}
                      </small>
                    </li>
                  ))}
                </ul>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowMessagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Add the Breakage Modal */}
          <Modal
            show={showBreakageModal}
            onHide={() => setShowBreakageModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Breakage/Damage Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    className="form-control message-box"
                    rows={3}
                    value={breakageDescription}
                    onChange={(e) => setBreakageDescription(e.target.value)}
                    placeholder="Enter damage description"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <div>
                    <Form.Check
                      type="radio"
                      label="Breakage"
                      name="breakageStatus"
                      id="breakage"
                      checked={breakageStatus === "breakage"}
                      onChange={(e) => setBreakageStatus("breakage")}
                      className="mb-2 cursor-pointer"
                    />
                    <Form.Check
                      type="radio"
                      label="No Breakage"
                      name="breakageStatus"
                      id="noBreakage"
                      checked={breakageStatus === "noBreakage"}
                      onChange={(e) => setBreakageStatus("noBreakage")}
                      className="cursor-pointer"
                    />
                  </div>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowBreakageModal(false)}
              >
                Close
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  handleBreakageSubmit();
                  setShowBreakageModal(false);
                }}
                disabled={!breakageDescription || !breakageStatus}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showDamageDetailsModal}
            onHide={() => setShowDamageDetailsModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Breakage/Damage Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {damageDetails ? (
                <div>
                  <p>
                    <strong>Description:</strong> {damageDetails.description}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {damageDetails.status === "breakage"
                      ? "Breakage"
                      : "No Breakage"}
                  </p>
                  <p>
                    <strong>Date:</strong>{" "}
                    {new Date(damageDetails.date).toLocaleString()}
                  </p>
                </div>
              ) : (
                <p>No damage details available.</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowDamageDetailsModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      )}

      {showEnquiryDeatils && (
        <EnquiryDetails
          Itemid={batchNo}
          handleCancle={handleCancelEnquiryDetails}
        />
      )}

      {showSalesOrder && (
        <SalesOrderNew
          customerName={custName}
          customerId={custId}
          enqNo={enqId}
          handleCancel={handleCancleSalesOrder}
        />
      )}

      {showDeliveryNote && (
        <DeliveryNote
          customerName={custName}
          customerId={custId}
          enqNo={enqId}
          handleCancel={handleCancleDeliveryNote}
        />
      )}

      {showInvoice && (
        <FollowupInvoice
          customerName={custName}
          customerId={custId}
          enqNo={enqId}
          handleCancel={handleCancleDeliveryNote}
        />
      )}

      {showQuotation && (
        <QuotationNew
          customerName={customerName}
          customerId={customerId}
          batchNo={batchNo}
          handleCanel={handleCancelQuotation}
        />
      )}

      {showProcurementProcess && (
        <ProcurementTracking
          customerName={customerName}
          customerId={customerId}
          batchNo={batchNo}
          type="fromFollowup"
          handleCancel={handleCancelProcurementProcess}
        />
      )}

      {/* {showQuotationDetails && (
        <QuotesDetails
          newinvoiceNumber={quoteId}
          custId={custId}
          handleCancel={handleCancelQuotationDetails}
        />
      )} */}
    </>
  );
};

export default OrderTracking;
